import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { compose } from 'redux';
import cx from 'classnames';

// Components
import Loader from '../Loader/Loader';
import NoDataSection from './NoDataSection';
import UserPlansContainer from './UserPlansContainer';
import PurchaseHistoryManagement from './PurchaseHistory/PurchaseHistoryManagement/PurchaseHistoryManagement';

// Helpers / Core
import messages from '../../locale/jsonMessages';
import history from '../../core/history';
import { getAllPurchaseServicePlans, getAllUserServicePlans } from '../../lib/graphql';
import { withQuery } from '../../hoc/withGraphql';

// Images
import NoServicePlanDataImg from '/public/SiteIcons/noServicePlan.svg';
import withStyles from 'isomorphic-style-loader/withStyles';

import cs from '../../components/commonStyle.css';


const ServicePlanContainer = (props) => {
    const { formatMessage } = useIntl();
    const { mode, userServicePlans, purchaseServicePlans } = props;

    const handleChangeService = (mode) => {
        if (mode === 'history') {
            purchaseServicePlans?.refetch({
                userType: 'renter',
                searchKey: '',
            });
        } else if (mode === 'renter') {
            userServicePlans?.refetch({
                userType: 'renter',
                searchKey: '',
            });
        }

        history.push(`/users/service-plans/${mode}`);
    };

    return (
        <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
            <ul className={cs.navTabFlex}>
                <li className={cs.displayBlock}>
                    <a onClick={() => handleChangeService('renter')} className={cx(cs.navTabLink, (mode == 'renter' || mode == 'owner') && cs.activeTabStyle)}>
                        <FormattedMessage {...messages.servicePlans} />
                    </a>
                </li>
                <li className={cs.displayBlock}>
                    <a onClick={() => handleChangeService('history')} className={cx(cs.navTabLink, mode === 'history' && cs.activeTabStyle)}>
                        <FormattedMessage {...messages.servicePlansHistory} />
                    </a>
                </li>
            </ul>
            {(userServicePlans?.loading && (mode === 'renter' || mode === 'owner')) && (<Loader type="text" />)}
            {purchaseServicePlans?.loading && mode === 'history' && (<Loader type="text" />)}
            {!userServicePlans?.loading && (mode == 'renter' || mode == 'owner') && userServicePlans?.getAllUserServicePlans?.count == 0 && (
                <NoDataSection
                    notFoundImg={NoServicePlanDataImg}
                    noDataTitle={formatMessage(messages.noServicePlanLabel)}
                    noDataDesc={formatMessage(messages.servicePlanContent)}
                    noDataNavBtnLink='/contact'
                    navLinkBtnText={formatMessage(messages.servicePlanContentOne)}
                    containerClass="servicePlanHistoryNoDataBox"
                />
            )}
            {!userServicePlans?.loading && (mode === 'renter' || mode === 'owner') && userServicePlans?.getAllUserServicePlans?.count > 0 && (
                <UserPlansContainer
                    data={userServicePlans}
                    mode={mode}
                />
            )}
            {!purchaseServicePlans?.loading && mode === 'history' && purchaseServicePlans?.getAllPurchaseServicePlans?.status === 200 && (
                <PurchaseHistoryManagement data={purchaseServicePlans} />
            )}
        </div>
    );
};


export default compose(
    withStyles(cs),
    withQuery(getAllUserServicePlans, {
        name: 'userServicePlans',
        options: (props) => ({
            variables: {
                searchKey: '',
                userType: props.mode,
            },
            fetchPolicy: 'network-only',
            ssr: false,
        }),
    }),
    withQuery(getAllPurchaseServicePlans, {
        name: 'purchaseServicePlans',
        options: (props) => ({
            variables: {
                currentPage: props.currentPage,
                searchKey: props.searchKey,
                userType: 'renter',
            },
            fetchPolicy: 'network-only',
            ssr: false,
        }),
    })
)(ServicePlanContainer);
